import { DIETARY_PREFERENCES as dp } from '../constants/constants';
import { getCurrentPathName } from '../utils/utils';

export const customerId = window.customerId;
export const getVolumeLimit = () => window.volumeLimit;
export const getColdVolumeLimit = () => window.coldVolumeLimit;

export const orderId = window.orderId;
export const maxPoints = window.maxPoints;
export const maxSameItem = Number.MAX_VALUE;
export const loadMoreSize = 20;
export const infiniteScrollNextLoadOffset = 625;
// set the limit to 0 unless, something is in the box, then set it to the qty in the box

// Router paths
export const recipesPath = `/edit-delivery/recipes/${
  getCurrentPathName().includes(window.orderId) ? `${window.orderId}/` : ''
}`;

// Filters categories:
const featuredFilterCat = 'featured';
const servingSizeFilterCat = 'serving_size';
export const proteinFilterCat = 'protein';
export const spicyLevelFilterCat = 'spicy_level';
const dietaryFilterCat = 'dietary';
const maxTimeFilterCat = 'max_cooking_time';
const maxCaloriesFilterCat = 'max_calories';
const yourRecipesFilterCat = 'favorite';

export const groceriesFilters = {
  [featuredFilterCat]: {
    title: 'featured',
    options: {
      is_new: { value: 'is_new', optionText: 'Newest Additions' },
      is_recent: { value: 'is_recent', optionText: 'Recent Groceries' },
      is_breakfast: { value: 'is_breakfast', optionText: 'Breakfast' },
      is_organic: { value: 'is_organic', optionText: 'Organic' },
    },
  },
  [proteinFilterCat]: {
    title: 'protein',
    options: {
      // the protein options are being added to the Redux store.
    },
  },
  [spicyLevelFilterCat]: {
    title: 'Spice Level',
    options: {
      0: { value: 0, optionText: 'No Heat' },
      1: { value: 1, optionText: 'Mild' },
      2: { value: 2, optionText: 'Medium' },
      3: { value: 3, optionText: 'Hot' },
    },
  },
  [dietaryFilterCat]: {
    title: 'dietary needs',
    options: {
      is_vegan: { value: dp.VEGAN, optionText: 'Vegan' },
      is_vegetarian: { value: dp.VEGETARIAN, optionText: 'Vegetarian' },
      is_pescatarian: { value: dp.PESCATARIAN, optionText: 'Pescatarian' },
      is_dairy_free: { value: dp.DAIRY_FREE, optionText: 'Dairy-Free' },
      is_gluten_free: { value: dp.GLUTEN_FREE, optionText: 'Gluten-Free' },
      is_soy_free: { value: dp.SOY_FREE, optionText: 'Soy-Free' },
      is_nut_free: { value: dp.NUT_FREE, optionText: 'Tree Nut-Free' },
      is_peanut_free: { value: dp.PEANUT_FREE, optionText: 'Peanut-Free' },
      is_egg_free: { value: dp.EGG_FREE, optionText: 'Egg-Free' },
      is_shellfish_free: {
        value: dp.SHELLFISH_FREE,
        optionText: 'Shellfish-Free',
      },
    },
  },
};

export const recipesFilters = {
  [yourRecipesFilterCat]: {
    title: 'Your Recipes',
    options: {
      filter_favorites: {
        value: 'filter_favorites',
        optionText: 'Saved Recipes',
      },
      is_recent: { value: 'is_recent', optionText: 'Recent Recipes' },
    },
  },
  [featuredFilterCat]: {
    title: 'featured',
    options: {
      is_new: { value: 'is_new', optionText: 'Newest Additions' },
      is_featured: { value: 'is_featured', optionText: "Chef's Picks" },
    },
  },
  [proteinFilterCat]: {
    title: 'protein',
    options: {
      // the protein options are being added to the Redux store.
    },
  },
  [spicyLevelFilterCat]: {
    title: 'Spice Level',
    options: {
      0: { value: 0, optionText: 'No Heat' },
      1: { value: 1, optionText: 'Mild' },
      2: { value: 2, optionText: 'Medium' },
      3: { value: 3, optionText: 'Hot' },
    },
  },
  [maxTimeFilterCat]: {
    title: 'cook Time',
    options: {
      5: { value: 5, optionText: '5 Minutes or Less' },
      10: { value: 10, optionText: '10 Minutes or Less' },
    },
  },
  [maxCaloriesFilterCat]: {
    title: 'nutrition',
    options: {
      500: { value: 500, optionText: '500 Calories or Less' },
    },
  },
  [dietaryFilterCat]: {
    title: 'dietary Needs',
    options: {
      is_vegan: { value: dp.VEGAN, optionText: 'Vegan' },
      is_vegetarian: { value: dp.VEGETARIAN, optionText: 'Vegetarian' },
      is_pescatarian: { value: dp.PESCATARIAN, optionText: 'Pescatarian' },
      is_dairy_free: { value: dp.DAIRY_FREE, optionText: 'Dairy-Free' },
      is_gluten_free: { value: dp.GLUTEN_FREE, optionText: 'Gluten-Free' },
      is_soy_free: { value: dp.SOY_FREE, optionText: 'Soy-Free' },
      is_nut_free: { value: dp.NUT_FREE, optionText: 'Tree Nut-Free' },
      is_peanut_free: { value: dp.PEANUT_FREE, optionText: 'Peanut-Free' },
      is_egg_free: { value: dp.EGG_FREE, optionText: 'Egg-Free' },
      is_shellfish_free: {
        value: dp.SHELLFISH_FREE,
        optionText: 'Shellfish-Free',
      },
    },
  },
};

export const searchToolFilters = {
  [yourRecipesFilterCat]: {
    title: 'Your Recipes',
    options: {
      filter_favorites: {
        value: 'filter_favorites',
        optionText: 'Saved Recipes',
      },
      is_recent: { value: 'is_recent', optionText: 'Recent Recipes' },
    },
  },
  [featuredFilterCat]: {
    title: 'featured',
    options: {
      is_new: { value: 'is_new', optionText: 'Newest Additions' },
      is_featured: { value: 'is_featured', optionText: "Chef's Picks" },
    },
  },
  [servingSizeFilterCat]: {
    title: 'serving size',
    options: {
      2: { value: 2, optionText: '2 Servings' },
      4: { value: 4, optionText: '4 Servings' },
    },
  },
  [proteinFilterCat]: {
    title: 'protein',
    options: {
      // the protein options are being added to the Redux store.
    },
  },
  [spicyLevelFilterCat]: {
    title: 'Spice Level',
    options: {
      0: { value: 0, optionText: 'No Heat' },
      1: { value: 1, optionText: 'Mild' },
      2: { value: 2, optionText: 'Medium' },
      3: { value: 3, optionText: 'Hot' },
    },
  },
  [maxTimeFilterCat]: {
    title: 'cook Time',
    options: {
      5: { value: 5, optionText: '5 Minutes or Less' },
      10: { value: 10, optionText: '10 Minutes or Less' },
    },
  },
  [maxCaloriesFilterCat]: {
    title: 'nutrition',
    options: {
      500: { value: 500, optionText: '500 Calories or Less' },
    },
  },
  [dietaryFilterCat]: {
    title: 'dietary Needs',
    options: {
      is_vegan: { value: dp.VEGAN, optionText: 'Vegan' },
      is_vegetarian: { value: dp.VEGETARIAN, optionText: 'Vegetarian' },
      is_pescatarian: { value: dp.PESCATARIAN, optionText: 'Pescatarian' },
      is_dairy_free: { value: dp.DAIRY_FREE, optionText: 'Dairy-Free' },
      is_gluten_free: { value: dp.GLUTEN_FREE, optionText: 'Gluten-Free' },
      is_soy_free: { value: dp.SOY_FREE, optionText: 'Soy-Free' },
      is_nut_free: { value: dp.NUT_FREE, optionText: 'Tree Nut-Free' },
      is_peanut_free: { value: dp.PEANUT_FREE, optionText: 'Peanut-Free' },
      is_egg_free: { value: dp.EGG_FREE, optionText: 'Egg-Free' },
      is_shellfish_free: {
        value: dp.SHELLFISH_FREE,
        optionText: 'Shellfish-Free',
      },
    },
  },
};

export const searchToolGroceriesFilters = {
  [featuredFilterCat]: {
    title: 'featured',
    options: {
      is_new: { value: 'is_new', optionText: 'Newest Additions' },
      is_breakfast: { value: 'is_breakfast', optionText: 'Breakfast' },
      is_organic: { value: 'is_organic', optionText: 'Organic' },
    },
  },
  [proteinFilterCat]: {
    title: 'protein',
    options: {
      // the protein options are being added to the Redux store.
    },
  },
  [spicyLevelFilterCat]: {
    title: 'Spice Level',
    options: {
      0: { value: 0, optionText: 'No Heat' },
      1: { value: 1, optionText: 'Mild' },
      2: { value: 2, optionText: 'Medium' },
      3: { value: 3, optionText: 'Hot' },
    },
  },
  [dietaryFilterCat]: {
    title: 'dietary needs',
    options: {
      is_vegan: { value: dp.VEGAN, optionText: 'Vegan' },
      is_vegetarian: { value: dp.VEGETARIAN, optionText: 'Vegetarian' },
      is_pescatarian: { value: dp.PESCATARIAN, optionText: 'Pescatarian' },
      is_dairy_free: { value: dp.DAIRY_FREE, optionText: 'Dairy-Free' },
      is_gluten_free: { value: dp.GLUTEN_FREE, optionText: 'Gluten-Free' },
      is_soy_free: { value: dp.SOY_FREE, optionText: 'Soy-Free' },
      is_nut_free: { value: dp.NUT_FREE, optionText: 'Tree Nut-Free' },
      is_peanut_free: { value: dp.PEANUT_FREE, optionText: 'Peanut-Free' },
      is_egg_free: { value: dp.EGG_FREE, optionText: 'Egg-Free' },
      is_shellfish_free: {
        value: dp.SHELLFISH_FREE,
        optionText: 'Shellfish-Free',
      },
    },
  },
};

export const isFoodsPage = ['/foods', '/foods/'].includes(
  window.location.pathname
);
export const recipesNumFiltersCat = {
  [maxTimeFilterCat]: true,
  [maxCaloriesFilterCat]: true,
};
export const groceriesNumFiltersCat = {};
export const recipesStrFilterCat = {};
export const groceriesStrFilterCat = {};
export const tagsFilterCat = {
  [proteinFilterCat]: true,
  [spicyLevelFilterCat]: true,
};

// catByRecipeStrFilter and catBySkuStrFilter map the options key for example "is_vegan" to the
// the filter category like "dietary", since in the response we have something like: is_vegan=1
export const catByRecipeStrFilter = Object.keys(recipesFilters).reduce(
  (aggr, key) => {
    if (recipesNumFiltersCat[key] || tagsFilterCat[key]) return aggr;
    Object.values(recipesFilters[key].options).forEach((option) => {
      // save non num filters categories
      if (!recipesStrFilterCat[key]) recipesStrFilterCat[key] = true;
      aggr[option.value] = key;
    });
    return aggr;
  },
  {}
);

export const catBySkuStrFilter = Object.keys(groceriesFilters).reduce(
  (aggr, key) => {
    Object.values(groceriesFilters[key].options).forEach((option) => {
      if (groceriesNumFiltersCat[key] || tagsFilterCat[key]) return aggr;
      if (!groceriesStrFilterCat[key]) groceriesStrFilterCat[key] = true;
      aggr[option.value] = key;
    });
    return aggr;
  },
  {}
);

// "All" options value in the recipes and groceries top filter bar.
export const allSpecialFilterKey = -1;

export const SORT_DEFAULT = 'sort_by_default';
const SORT_POINTS = 'sort_by_points';

export const sortByOptions = {
  [SORT_DEFAULT]: { optionText: 'Default', value: SORT_DEFAULT },
  [SORT_POINTS]: { optionText: 'Credits', value: SORT_POINTS },
};

export const segmentBaseInfo = {
  orderId: orderId,
  context: {
    app: {
      name: 'Hunryroot Web',
      namespace: 'Hungryroot.com',
    },
  },
};
